export default __webpack_public_path__ + "static/media/icon1.466d1442.svg";